import { Hero } from "@/components/Hero";
import { Ticker } from "@/components/Ticker";
import { Revier } from "@/components/Revier";
import { LiveHunt } from "@/components/LiveHunt";
import { Toolkit } from "@/components/Toolkit";
import { Tutorials } from "@/components/Tutorials";
import { Praxis } from "@/components/Praxis";
import { Skadi } from "@/components/Skadi";
import { Pricing } from "@/components/Pricing";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { useLanguage } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export const Landing = () => {
  const { t, lang } = useLanguage();
  usePageMeta({ title: t.meta.title, description: t.meta.description, path: "/", lang });
  return (
  <>
    <Hero />
    <Ticker />
    <Revier />
    <LiveHunt />
    <Toolkit />
    <Praxis />
    <Tutorials />
    <Skadi />
    <Pricing />
    <FAQ />
    <FinalCTA />
  </>
  );
};
